import { Navigate, Route, Routes } from 'react-router-dom'

import { Home } from '~/components/Pages/Home'
import { Login } from '~/components/Pages/Login'
import { NotFound } from '~/components/Pages/NotFound'
import { OssLicenses } from '~/components/Pages/OssLicenses'
import { Report } from '~/components/Pages/Report'
import { SSO } from '~/components/Pages/SSO'
import { NAV_LINKS } from '~/constants'
import { DrawerLayout } from '~/layouts/Drawer'
import { GARoute } from '~/layouts/GARoute'

import { useUser } from '~/lib/auth'

export function AppRoutes() {
  const user = useUser()

  return (
    <Routes>
      <Route element={<GARoute />}>
        <Route path="/" element={<Navigate to={user.data ? NAV_LINKS.HOME.to : NAV_LINKS.SIGNIN.to} replace />} />
        <Route index={true} path={NAV_LINKS.SIGNIN.to} element={<Login />} />
        <Route path={'/sso'} element={<SSO />} />
        <Route path={NAV_LINKS.OSS_LICENSES.to} element={<OssLicenses />} />
        <Route element={<DrawerLayout />}>
          <Route path={NAV_LINKS.HOME.to} element={<Home />} />
          <Route path={NAV_LINKS.REPORT.to} element={<Report />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}
